<template>
  <section>
    <vue-headful
      title="Thong Firearms | ร้านปืนธง จำหน่ายปืนร้าน ปืนสั้น ปืนยาว"
      description="ร้านปืนธง จำหน่ายปืน ขายปืน เชี่ยวชาญทางด้านปืน เมื่อปี พ.ศ.2540 ทางโรงงาน Smith&Wesson ได้เรียนเชิญเจ้าของร้านปืนธงไปที่งาน Shot Show ที่ประเทศสหรัฐอเมริกา เพื่อเปิดตัว Performance Center ได้รับอนุญาตให้ขายปืนถูกต้องตามกฎหมาย"
      keyword="ปืนสั้น ปืนยาว, ปืนร้าน, ปืนถูกกฎหมาย, ปืนสั้น, ปืนยาว, ปืนดี, Smith&Wesson, ปืนราคาถูก, การขอใบ ป.3, ซื้อปืน, อนุญาตซื้อปืน, หลักฐานการซื้อปืน"
      image="https://thongarms.com/dist/logo.png"
      lang="th"
    />
    <div class="container">
      <b-carousel
        id="myCarousel"
        style="text-shadow: 0px 0px 2px #000;"
        class="slide wow fadeIn"
        fade
        v-model="slide"
        :interval="4000"
        controls
        indicators
      >
        <b-carousel-slide
          :img-src="slides[0]"
          img-alt="ปืนยาวลูกซอง STANDARD MFG"
        ></b-carousel-slide>
        <b-carousel-slide
          :img-src="slides[1]"
          img-alt="ปืนสั้นลูกโม่ COLT"
        ></b-carousel-slide>
        <b-carousel-slide
          :img-src="slides[2]"
          img-alt="ปืนสั้นกึ่งอัตโนมัติ John Wick 3 STI COMBAT MASTER"
        ></b-carousel-slide>
      </b-carousel>
      <div class="grid-container product-type">
        <div class="row">
          <div class="max-width col-12 col-sm-6 col-lg-4 mb-3">
            <router-link to="/type/4/2" class="overlay">
              <img
                class="mw-100"
                src="../assets/R-T1.jpg"
                alt="ปืนยาว ลูกเลื่อน"
              />
              <span class="caption">ปืนยาว ลูกเลื่อน</span>
            </router-link>
          </div>
          <div class="max-width col-12 col-sm-6 col-lg-4 mb-3">
            <router-link to="/type/3/2" class="overlay">
              <img
                class="mw-100"
                src="../assets/R-T2.jpg"
                alt="ปืนยาว ลูกซอง"
              />
              <span class="caption">ปืนยาว ลูกซอง</span>
            </router-link>
          </div>
          <div class="max-width col-12 col-sm-6 col-lg-4 mb-3">
            <router-link to="/type/1/2" class="overlay">
              <img
                class="mw-100"
                src="../assets/R-T3.jpg"
                alt="ปืนยาว กึ่งอัตโนมัติ"
              />
              <span class="caption">ปืนยาว กึ่งอัตโนมัติ</span>
            </router-link>
          </div>
          <!-- <div class="max-width col-12 col-sm-6 col-lg-4 mb-3">
            <router-link to="/type/5/2" class="overlay">
              <img class="mw-100" src="../assets/R-T4.jpg" alt="ปืนยาว คานเหวี่ยง" />
              <span class="caption">ปืนยาว คานเหวี่ยง</span>
            </router-link>
          </div> -->
          <div class="max-width col-12 col-sm-6 col-lg-4 mb-3">
            <router-link to="/type/1/1" class="overlay">
              <img
                class="mw-100"
                src="../assets/S-T1.jpg"
                alt="ปืนสั้น กึ่งอัตโนมัติ"
              />
              <span class="caption">ปืนสั้น กึ่งอัตโนมัติ</span>
            </router-link>
          </div>
          <div class="max-width col-12 col-sm-6 col-lg-4 mb-3">
            <router-link to="/type/2/1" class="overlay">
              <img
                class="mw-100"
                src="../assets/S-T2.jpg"
                alt="ปืนสั้น ลูกโม่"
              />
              <span class="caption">ปืนสั้น ลูกโม่</span>
            </router-link>
          </div>
          <div class="max-width col-12 col-sm-6 col-lg-4 mb-3">
            <div class="overlay">
              <img class="mw-100" src="../assets/L-T0.jpg" alt="ร้านปืนธง" />
              <span class="caption">ร้านปืนธง</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container mb-4">
      <h2 class="mt-4 mb-4">ปืนร้าน</h2>
      <div class="grid-container">
        <div
          class="row"
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="busy"
          infinite-scroll-throttle-delay="300"
        >
          <div
            v-for="arm in arms"
            :key="arm.id"
            class="col-12 col-sm-6 col-md-6 col-lg-3 mb-3 mb-sm-4 wow fadeInUp"
          >
            <div class="item">
              <div class="img-product max-width d-flex align-items-center">
                <img
                  v-bind:src="'src/assets/product/' + arm.img"
                  :alt="`ปืนร้านปืนธง ${arm.name}`"
                  :title="arm.name"
                />
              </div>

              <div id="product-detail" class="mt-3">
                <h5 :title="arm.name">{{ arm.name }}</h5>

                <p class="color-70">{{ arm.detail | snippet }}</p>
              </div>
              <div id="read-more" class="text-center">
                <router-link v-bind:to="'/product/' + arm.id" class="btn"
                  >รายละเอียด</router-link
                >
              </div>
            </div>
          </div>
          <div
            class="w-100 text-center wow fadeInUp"
            id="read-more"
            v-if="!isTriggedLoadMore && !completed"
          >
            <a class="btn" @click="isTriggedLoadMore = true"
              >ดูสินค้าเพิ่มเติม</a
            >
          </div>
          <div class="w-100 text-center wow fadeInUp" v-if="completed">
            สินค้าร้านปืนธง :)
          </div>
          <div
            class="w-100 text-center wow fadeInUp"
            v-if="busy || isTriggedLoadMore"
          >
            <div class="spinner-grow text-danger" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="container mb-4">
      <h2 class="mt-4 mb-4">ปืนสั้นสวัสดิการกรมการปกครอง</h2>
      <div class="grid-container">
        <div
          class="row"
          v-infinite-scroll="loadMoreWelfare"
          infinite-scroll-disabled="busyWelfare"
          infinite-scroll-throttle-delay="300"
        >
          <div
            v-for="arm in activeWelfares"
            :key="arm.id"
            class="col-12 col-sm-6 col-md-6 col-lg-3 mb-3 mb-sm-4 wow fadeInUp"
          >
            <div class="item">
              <div class="img-product max-width d-flex align-items-center">
                <img
                  v-bind:src="'src/assets/product/' + arm.img"
                  :alt="`ปืนสวัสดิการ, ปืนสั้นสวัสดิการ ${arm.name}`"
                  title="ปืนสั้นสวัสดิการกรมการปกครอง"
                />
              </div>

              <div id="product-detail" class="mt-3">
                <h5 :title="arm.name">{{ arm.name }}</h5>
                <p class="color-70">{{ arm.detail | snippet }}</p>
              </div>
              <div id="read-more" class="text-center">
                <router-link v-bind:to="'/welfare/' + arm.id" class="btn"
                  >รายละเอียด</router-link
                >
              </div>
            </div>
          </div>
          <div
            class="w-100 text-center wow fadeInUp"
            id="read-more"
            v-if="!isTriggedLoadMoreWelfare && !completedWelfare"
          >
            <a class="btn" @click="isTriggedLoadMoreWelfare = true"
              >ดูสินค้าเพิ่มเติม</a
            >
          </div>
          <div class="w-100 text-center wow fadeInUp" v-if="completedWelfare">
            สินค้าสวัสดิการปืนธง :)
          </div>
          <div
            class="w-100 text-center wow fadeInUp"
            v-if="busyWelfare || isTriggedLoadMoreWelfare"
          >
            <div class="spinner-grow text-danger" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </section>
</template>

<script>
//import { db } from '../config_db';

// import { setupFirebase } from '../config_db'
// const firebase = setupFirebase({});

// let db = firebase.database();
// let armsRef = db.ref('product');
// let id = window.location.hash;

export default {
  data() {
    return {
      arms: [],
      welfares: [],
      busy: false,
      isTriggedLoadMore: true,
      completed: false,
      limit: 8,
      busyWelfare: false,
      isTriggedLoadMoreWelfare: true,
      completedWelfare: false,
      limitWelfare: 4,
      slides: [
        require("../assets/slide9.jpg"),
        require("../assets/slide2.jpg"),
        require("../assets/slide3.jpg")
      ],
      slide: 0,
      sliding: null,
      brands: [
        { pic: "1.jpg", bid: "9" },
        { pic: "2.jpg", bid: "1" },
        { pic: "3.jpg", bid: "4" },
        { pic: "4.jpg", bid: "2" }
      ]
    };
  },
  created() {
    this.loadMore();
    this.loadMoreWelfare();
    setTimeout(() => {
      this.isTriggedLoadMore = false;
    }, 1500);
    setTimeout(() => {
      this.isTriggedLoadMoreWelfare = false;
    }, 2000);
    // this.loadMore();
    // this.$http
    //   .get("https://thongarms-2506.firebaseio.com/product.json")
    //   .then(function(data) {
    //     return data.json();
    //   })
    //   .then(function(data) {
    //     var dataArray = [];
    //     for (let key in data) {
    //       var i = parseInt(key) + 1;
    //       if (key == 0) {
    //       } else {
    //         dataArray.push(data[key]);
    //       }
    //       // console.log(dataArray);
    //     }
    //     // console.log(data);
    //     this.arms = dataArray;
    //   });
  },
  computed: {
    activeArms() {
      return this.arms.filter(function(u) {
        return u.show != false && u.show != "FALSE";
      });
    },
    activeWelfares() {
      return this.welfares.filter(function(u) {
        return u.show != false && u.show != "FALSE";
      });
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    loadMore() {
      if (!this.completed && this.isTriggedLoadMore) {
        this.busy = true;

        this.$http
          .get("https://thongarms-2506.firebaseio.com/product.json")
          .then(data => {
            return data.json();
          })
          .then(response => {
            response = response.filter(function(u) {
              return u != null && u.show != false && u.show != "FALSE";
            });
            if (this.arms.length + 1 < response.length) {
              const append = response.slice(
                this.arms.length + 1,
                this.arms.length + 1 + this.limit
              );
              this.arms = this.arms.concat(append);
              this.busy = false;
            } else {
              this.completed = true;
              this.busy = false;
            }
          });
      } else {
        this.busy = false;
        this.isTriggedLoadMore = false;
      }
    },
    loadMoreWelfare() {
      if (!this.completedWelfare && this.isTriggedLoadMoreWelfare) {
        this.busyWelfare = true;

        this.$http
          .get("https://thongarms-2506.firebaseio.com/welfare.json")
          .then(data => {
            return data.json();
          })
          .then(response => {
            response = response.filter(function(u) {
              return u != null && u.show != false && u.show != "FALSE";
            });
            if (this.welfares.length + 1 < response.length) {
              const append = response.slice(
                this.welfares.length + 1,
                this.welfares.length + 1 + this.limitWelfare
              );
              this.welfares = this.welfares.concat(append);
              this.busyWelfare = false;
            } else {
              this.completedWelfare = true;
              this.busyWelfare = false;
            }
          });
      } else {
        this.busyWelfare = false;
        this.isTriggedLoadMoreWelfare = false;
      }
    }
  }
};
</script>

<style scoped>
#myCarousel {
  margin: 30px 0;
}
.grid-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.grid-item img {
  -webkit-transition: all 0.1s ease-in;
  transition: all 0.1s ease-in;
  opacity: 0.95;
  padding: 5px;
}
.grid-item img:hover {
  transform: scale(1.005);
  opacity: 1;
  border: dashed 5px #888;
  padding: 0px;
}
.item:hover #read-more a,
#read-more a:hover {
  background: #eb1c23;
  color: #fff;
}
.item {
  border: 1px solid rgb(212, 210, 210);
  padding: 15px;

  transition: all 0.3s;
  -webkit-transition: all 0.3s;
}
.item:hover {
  border: 1px solid #111;
}
.img-product {
  height: 210px;
  overflow: hidden;
  margin: 15px 0;
}
.product-type {
  float: left;
  position: relative;
}
.product-type img {
  opacity: 0.98;
  transition: opacity 0.25s ease;
}
.product-type img:hover {
  opacity: 1;
}
.product-type .overlay {
  text-decoration: none;
}

.product-type .overlay .caption {
  align-items: center;
  background: black;
  color: #fff;
  display: flex;
  font-size: 1.75rem;
  font-weight: 300;
  justify-content: center;
  opacity: 0;
  position: absolute;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  top: 25%;
  bottom: 25%;
  left: 50%;
  right: 50%;
  visibility: hidden;
  transition: all 0.5s ease-in-out;
}

.product-type .overlay:hover .caption {
  opacity: 0.9;
  visibility: visible;
  top: 0;
  bottom: 0;
  left: 4%;
  right: 4%;
}

.product-type img {
  display: block;
}
@media screen and (min-width: 100px) and (max-width: 812px) {
  .grid-container--category {
    grid-template-columns: auto;
    grid-gap: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/component/mainpage.vue